import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import showDialog from "../../../utils/ShowDialog/ShowDialog";
import * as StandAloneProcessService from "../../../../services/StandAloneProcessService";
import {
  STANDALONE_EXPEDITION,
  STANDALONE_PROCESS_VERTICAL_SEC,
} from "../../../../constants";

export const useStandAloneProcess = (processType) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [initial, setInitial] = useState({});
  const [data, setData] = useState(null);

  useEffect(() => {
    if (processType === STANDALONE_EXPEDITION.code) {
      StandAloneProcessService.getExpedition().then((result) => {
        if (result) {
          setData(result);
        }
      });
    } else {
      StandAloneProcessService.getStandAloneProcess(processType).then(
        (result) => {
          if (result) {
            setData(result);
          }
        }
      );
    }
  }, []);

  const createStandAloneProcess = async (values, reset = null) => {
    try {
      if (processType === STANDALONE_EXPEDITION.code) {
        const result = await StandAloneProcessService.createExpedition(
          values,
          processType
        );
        if (result) {
          setData(result);
          if (reset) {
            reset();
          }
          // handlerClosePopup();

          showDialog(
            t("forms.standAloneProcess.messages.create.title"),
            t("forms.standAloneProcess.messages.create.success"),
            "success",
            false,
            "Ok"
          );
        }
      } else {
        const result = await StandAloneProcessService.createStandAloneProcess(
          values,
          processType
        );
        if (result) {
          setData(result);
          if (reset) {
            reset();
          }
          // handlerClosePopup();

          showDialog(
            t("forms.standAloneProcess.messages.create.title"),
            t("forms.standAloneProcess.messages.create.success"),
            "success",
            false,
            "Ok"
          );
        }
      }
    } catch (error) {}
  };

  const registerBB = async (type, values, reset = null) => {
    try {
      if (processType === STANDALONE_EXPEDITION.code) {
        const result = await StandAloneProcessService.registerBBExp(
          values,
          type,
          processType
        );
        if (result) {
          setData(result);
          if (reset) {
            reset();
          }
          showDialog(
            t("forms.standAloneProcess.messages.registerBB.title"),
            t("forms.standAloneProcess.messages.registerBB.text"),
            "success",
            false,
            "Ok"
          );
        }
      } else {
        if (
          processType !== STANDALONE_PROCESS_VERTICAL_SEC.code &&
          !values.outPoint &&
          type === "OUT"
        ) {
          showDialog(
            t("forms.standAloneProcess.messages.registerBB.title"),
            t("forms.standAloneProcess.messages.registerBB.errorOutPoint"),
            "error",
            false,
            "Ok"
          );
          return false;
        }
        if (type) {
          const result = await StandAloneProcessService.registerBB(
            values,
            type,
            processType
          );
          if (result) {
            setData(result);
            if (reset) {
              reset();
            }
            showDialog(
              t("forms.standAloneProcess.messages.registerBB.title"),
              t("forms.standAloneProcess.messages.registerBB.text"),
              "success",
              false,
              "Ok"
            );
          }
        }
      }
    } catch (error) {}
  };

  const executeRemove = async (bb) => {
    try {
      let result;
      if (processType === STANDALONE_EXPEDITION.code) {
        result = await StandAloneProcessService.removeItemExp(bb.uuid);
      } else {
        result = await StandAloneProcessService.removeItem(
          bb.uuid,
          processType
        );
      }

      if (result) {
        setData(result);
        // if (reset) {
        //   reset();
        // }
        showDialog(
          t("forms.standAloneProcess.messages.remove.title"),
          t("forms.standAloneProcess.messages.remove.text"),
          "success",
          false,
          "Ok"
        );
      }
    } catch (error) {}
  };

  const handlerRemove = async (bb) => {
    try {
      const okAction = () => {
        executeRemove(bb);
      };

      const cancelAction = () => {};

      showDialog(
        t("forms.standAloneProcess.dialog.remove.title"),
        t("forms.standAloneProcess.dialog.remove.text"),
        "warning",
        true,
        t("forms.standAloneProcess.dialog.remove.buttonOk"),
        false,
        okAction,
        t("forms.standAloneProcess.dialog.remove.buttonNo"),
        cancelAction
      );
    } catch (error) {}
  };

  const executeFinish = async () => {
    try {
      let result;
      if (processType === STANDALONE_EXPEDITION.code) {
        result = await StandAloneProcessService.finishStandAloneProcessExp();
      } else {
        result = await StandAloneProcessService.finishStandAloneProcess(
          processType
        );
      }

      if (result && result === "OK") {
        setData(null);
        //   handlerClosePopup();
        showDialog(
          t("forms.standAloneProcess.messages.finish.title"),
          t("forms.standAloneProcess.messages.finish.text"),
          "success",
          false,
          "Ok"
        );
      }
    } catch (error) {}
  };

  const handlerFinish = async (totalIn, totalOut) => {
    try {
      let result;
      if (processType === STANDALONE_EXPEDITION.code) {
        if (totalIn <= 0) {
          showDialog(
            t("forms.standAloneProcess.messages.finish.title"),
            t("forms.standAloneProcess.messages.finish.errorIn"),
            "error",
            false,
            "Ok"
          );
          return false;
        }
      } else {
        if (totalOut <= 0) {
          showDialog(
            t("forms.standAloneProcess.messages.finish.title"),
            t("forms.standAloneProcess.messages.finish.errorOut"),
            "error",
            false,
            "Ok"
          );
          return false;
        }
        if (totalIn <= 0) {
          showDialog(
            t("forms.standAloneProcess.messages.finish.title"),
            t("forms.standAloneProcess.messages.finish.errorIn"),
            "error",
            false,
            "Ok"
          );
          return false;
        }
      }

      const okAction = () => {
        executeFinish();
      };
      const cancelAction = () => {};
      showDialog(
        t("forms.standAloneProcess.dialog.finish.title"),
        t("forms.standAloneProcess.dialog.finish.text"),
        "question",
        true,
        t("forms.standAloneProcess.dialog.finish.buttonOk"),
        false,
        okAction,
        t("forms.standAloneProcess.dialog.finish.buttonNo"),
        cancelAction
      );
    } catch (error) {}
  };

    const handlerDelete = async (uuid, type, totalIn, totalOut) => {
    try {
      const okAction = async () => {
        try {
          if (totalIn > 0) {
            showDialog(
              t("forms.standAloneProcess.messages.delete.titleError"),
              t("forms.standAloneProcess.messages.delete.errorIn"),
              "error",
              false,
              "Ok"
            );
            return false;
          }
          if (totalOut > 0) {
            showDialog(
              t("forms.standAloneProcess.dialog.delete.titleError"),
              t("forms.standAloneProcess.dialog.delete.errorOut"),
              "error",
              false,
              "Ok"
            );
            return false;
          }
          const result = await StandAloneProcessService.deleteStandAloneProcess(
            uuid
          );

          if (result) {
            setData(null);
            showDialog(
              t("forms.standAloneProcess.dialog.delete.titleSuccess"),
              t("forms.standAloneProcess.dialog.delete.textSuccess"),
              "success",
              false,
              "Ok"
            );
          }
        } catch (error) {
          showDialog(
            t("forms.standAloneProcess.dialog.delete.errorTitle"),
            t("forms.standAloneProcess.dialog.delete.errorText"),
            "error",
            false,
            "Ok"
          );
        }
      };

      const cancelAction = () => {};

      showDialog(
        t("forms.standAloneProcess.dialog.delete.title"),
        t("forms.standAloneProcess.dialog.delete.text"),
        "question",
        true,
        t("forms.standAloneProcess.dialog.delete.buttonOk"),
        false,
        okAction,
        t("forms.standAloneProcess.dialog.delete.buttonNo"),
        cancelAction
      );
    } catch (error) {
      console.error("Error en handlerDelete:", error);
    }
  };

  return {
    data,
    createStandAloneProcess,
    registerBB,
    handlerRemove,
    handlerFinish,
    handlerDelete
  };
};
